import { mainBus, MenuShareEvent, MoreMenuEvent, NicheEditEvent } from "utils/bus";

export const onShare = (options: MenuShareEvent) => {
  mainBus.emit("gif_share_open", options);
};

export const onMenu = (options: MoreMenuEvent) => {
  mainBus.emit("gif_menu_open", options);
};

export const onNicheEdit = (options: NicheEditEvent) => {
  mainBus.emit("niche_edit_open", options);
};
